<template>
  <div></div>
</template>

<script>
export default {
  name: 'Deeplink',
  props: {},
  data () {
    return {}
  },

  created () {
    this.$root.redirect = this.$route
    this.$router.push('/dashboard')
  },
  methods: {
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
